<template>
  <div class="cnehl-main" :style="{ 
    'width': '100%',
    'height': '100%',
    'position': 'relative'}">
    <div class="reprint" :style="{
      'width': `${67 * zoomLevel}px`,
      'height': `${15 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${9 * zoomLevel}px`,
      'left': `${720 * zoomLevel}px`, }">
      {@Reprint}
    </div>
    <div class="userid" :style="{
      'width': `${67 * zoomLevel}px`,
      'height': `${15 * zoomLevel}px`,
      'font-size': `${8 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${22 * zoomLevel}px`,
      'left': `${720 * zoomLevel}px`, }">
      {{ job['userid'] }}
    </div>
    <div class="urgency" :style="{
      'width': `${100 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${68 * zoomLevel}px`,
      'left': `${530 * zoomLevel}px`, }">
      {{ job['Urgent'] == '1' ? 'URGENT' : '' }}
    </div>
    <div class="office-hour" :style="{
      'width': `${150 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${113 * zoomLevel}px`,
      'left': `${40 * zoomLevel}px`, }">
      {{ cn['OfficeHours'] == '1' ? 'OFFICE HR' : cn['OfficeHours'] == '0' ? '24 HRS' : '' }}
    </div>
    <div class="last-day" :style="{
      'width': `${150 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${113 * zoomLevel}px`,
      'left': `${300 * zoomLevel}px`, }">
      {{ getLastDay() }}
    </div>
    <div class="booking-ref" :style="{
      'width': `${198 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${138 * zoomLevel}px`,
			'left': `${138 * zoomLevel}px`, }">
      {{ job['Booking Ref No'] }}
    </div>
    <div class="request-no" :style="{
      'width': `${98 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${137 * zoomLevel}px`,
			'left': `${444 * zoomLevel}px`, }">
      {{ job['Request No'] }}
    </div>
    <div class="cn-no" :style="{
      'width': `${118 * zoomLevel}px`,
      'height': `${39 * zoomLevel}px`,
      'font-size': `${12 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${190 * zoomLevel}px`,
      'left': `${15 * zoomLevel}px`, }">
      {{ cn['ConsignmentNo'] }}
    </div>
    <div class="date-time" :style="{
      'width': `${96 * zoomLevel}px`,
			'height': `${39 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${190 * zoomLevel}px`,
			'left': `${140 * zoomLevel}px`, }">
      {{ $dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm') }}
    </div>
    <div class="acc-no" :style="{
      'width': `${96 * zoomLevel}px`,
			'height': `${39 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${190 * zoomLevel}px`,
			'left': `${241 * zoomLevel}px`, }">
      {Account No}
    </div>
    <div class="haulage-amt" :style="{
      'width': `${96 * zoomLevel}px`,
			'height': `${24 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${204 * zoomLevel}px`,
			'left': `${343 * zoomLevel}px`, }">
      {{ cn['HaulageRate'] }}
    </div>
    <div class="toll-amt" :style="{
      'width': `${96 * zoomLevel}px`,
			'height': `${24 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${204 * zoomLevel}px`,
			'left': `${445 * zoomLevel}px`, }">
      {{ cn['TollRate'] }}
    </div>
    <div class="others-amt" :style="{
      'width': `${96 * zoomLevel}px`,
			'height': `${24 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${204 * zoomLevel}px`,
			'left': `${548 * zoomLevel}px`, }">
      {Others Amount}
    </div>
    <div class="total-amt" :style="{
      'width': `${96 * zoomLevel}px`,
			'height': `${24 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${204 * zoomLevel}px`,
			'left': `${651 * zoomLevel}px`, }">
      {{ getTotalAmount() }}
    </div>
    <div class="cont-no" :style="{
      'width': `${221 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${242 * zoomLevel}px`,
			'left': `${15 * zoomLevel}px`, }">
      {{ cn['ContainerNo'] }}
    </div>
    <div class="size" :style="{
      'width': `${196 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${242 * zoomLevel}px`,
			'left': `${243 * zoomLevel}px`, }">
      {{ cn['ContSize'] }}
    </div>
    <div class="height" :style="{
      'width': `${149 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${242 * zoomLevel}px`,
			'left': `${448 * zoomLevel}px`, }">
      {{ cn['ContHeight'] }}
    </div>
    <div class="gross-weight" :style="{
      'width': `${143 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${242 * zoomLevel}px`,
			'left': `${603 * zoomLevel}px`, }">
      {{ cn['ContWeight'] }}
    </div>
    <div class="cont-type" :style="{
      'width': `${221 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${273 * zoomLevel}px`,
			'left': `${15 * zoomLevel}px`, }">
      {{ cn['ContType'] }}
    </div>
    <div class="status" :style="{
      'width': `${196 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${273 * zoomLevel}px`,
			'left': `${243 * zoomLevel}px`, }">
      {{ cn['Status'] }}
    </div>
    <div class="seal" :style="{
      'width': `${149 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${273 * zoomLevel}px`,
			'left': `${448 * zoomLevel}px`, }">
      {{ cn['SealNo'] }}
    </div>
    <div class="measurement" :style="{
      'width': `${143 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${273 * zoomLevel}px`,
			'left': `${603 * zoomLevel}px`, }">
      {{ cn['ContMeasure'] }}
    </div>
    <div class="import-export-others" :style="{
      'width': `${221 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${305 * zoomLevel}px`,
			'left': `${15 * zoomLevel}px`, }">
      {{ job['Job Type'] }}
    </div>
    <div class="temperature" :style="{
      'width': `${196 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${305 * zoomLevel}px`,
			'left': `${243 * zoomLevel}px`, }">
      {{ cn['Temperature'] }}
    </div>
    <div class="cargo" :style="{
      'width': `${149 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${305 * zoomLevel}px`,
			'left': `${448 * zoomLevel}px`, }">
      {Cargo}
    </div>
    <div class="trip" :style="{
      'width': `${143 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${305 * zoomLevel}px`,
			'left': `${603 * zoomLevel}px`, }">
      {{ job['Trip'] }}
    </div>
    <div class="vessel-name" :style="{
      'width': `${424 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${337 * zoomLevel}px`,
			'left': `${15 * zoomLevel}px`, }">
      {{ job['Vessel No'] }} {{ job['Vessel Name'] }}
    </div>
    <div class="special-handling" :style="{
      'width': `${298 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${337 * zoomLevel}px`,
			'left': `${448 * zoomLevel}px`, }">
      {{ cn['HandlingType'] }}
    </div>
    <div class="voyage-no" :style="{
      'width': `${221 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${370 * zoomLevel}px`,
			'left': `${15 * zoomLevel}px`, }">
      {{ job['Voy No'] }}
    </div>
    <div class="eta" :style="{
      'width': `${196 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${370 * zoomLevel}px`,
			'left': `${243 * zoomLevel}px`, }">
      {{ Date.parse(job['POD ETA']) ? $dateTime.getDateTime(new Date(job['POD ETA']), 'dd/MM/yyyy HH:mm') : '' }}
    </div>
    <div class="delivery-type" :style="{
      'width': `${298 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${370 * zoomLevel}px`,
			'left': `${448 * zoomLevel}px`, }">
      {{ cn['DeliveryType'] }}
    </div>
    <div class="trans-port" :style="{
      'width': `${221 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${401 * zoomLevel}px`,
			'left': `${15 * zoomLevel}px`, }">
      {{ job['Transhipment Port'] }}
    </div>
    <div class="dest-port" :style="{
      'width': `${196 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${401 * zoomLevel}px`,
			'left': `${243 * zoomLevel}px`, }">
      {Destination Port}
    </div>
    <div class="port-code" :style="{
      'width': `${298 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${12 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${401 * zoomLevel}px`,
			'left': `${448 * zoomLevel}px`, }">
      {Port Code}
    </div>
    <div class="pickup" :style="{
      'width': `${360 * zoomLevel}px`,
      'height': `${39 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${442 * zoomLevel}px`,
      'left': `${18 * zoomLevel}px`, }">
      {{ cn['PickUp'] }}
    </div>
    <div class="contact-person" :style="{
      'width': `${179 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${480 * zoomLevel}px`,
      'left': `${18 * zoomLevel}px`, }">
      {Contact Person}
    </div>
    <div class="tel" :style="{
      'width': `${179 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${480 * zoomLevel}px`,
      'left': `${199 * zoomLevel}px`, }">
      {Tel}
    </div>
    <div class="bill-to" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${57 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${440 * zoomLevel}px`,
			'left': `${390 * zoomLevel}px`, }">
      {Bill To}
    </div>
    <div class="deliver-to" :style="{
      'width': `${360 * zoomLevel}px`,
			'height': `${52 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${521 * zoomLevel}px`,
			'left': `${18 * zoomLevel}px`, }">
      {{ cn['SendTo'] }}
    </div>
    <div class="contact-person" :style="{
      'width': `${179 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${572 * zoomLevel}px`,
      'left': `${18 * zoomLevel}px`, }">
      {Contact Person Del}
    </div>
    <div class="tel" :style="{
      'width': `${179 * zoomLevel}px`,
      'height': `${18 * zoomLevel}px`,
      'font-size': `${10 * zoomLevel}px`,
      'position': 'absolute',
      'top': `${572 * zoomLevel}px`,
      'left': `${199 * zoomLevel}px`, }">
      {Tel Del}
    </div>
    <div class="shipper" :style="{
      'width': `${355 * zoomLevel}px`,
			'height': `${72 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${521 * zoomLevel}px`,
			'left': `${390 * zoomLevel}px`, }">
      {Shipper / Consignee}
    </div>
    <div class="drop-off" :style="{
      'width': `${360 * zoomLevel}px`,
			'height': `${72 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${622 * zoomLevel}px`,
			'left': `${18 * zoomLevel}px`, }">
      {{ cn['DropOff'] }}
    </div>
    <div class="fumigation" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${20 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${698 * zoomLevel}px`,
			'left': `${18 * zoomLevel}px`, }">
      {{ cn['Fumigation'] == '1' ? 'YES' : cn['Fumigation'] == '0' ? 'NO' : '' }}
    </div>
    <div class="required-date" :style="{
      'width': `${95 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${617 * zoomLevel}px`,
			'left': `${520 * zoomLevel}px`, }">
      {{ Date.parse(cn['RequiredTime']) ? $dateTime.getDateTime(new Date(cn['RequiredTime']), 'dd/MM/yyyy') : '' }}
    </div>
    <div class="required-time" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${617 * zoomLevel}px`,
			'left': `${650 * zoomLevel}px`, }">
      {{ Date.parse(cn['RequiredTime']) ? $dateTime.getDateTime(new Date(cn['RequiredTime']), 'HH:mm') : '' }}
    </div>
    <div class="offload" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${630 * zoomLevel}px`,
			'left': `${650 * zoomLevel}px`, }">
      {{ job['OffLoad'] }}
    </div>
    <div class="forwarder" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${647 * zoomLevel}px`,
			'left': `${520 * zoomLevel}px`, }">
      {{ job['Frt Forwarder Name'] }}
    </div>
    <div class="shipping-agent" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${662 * zoomLevel}px`,
			'left': `${520 * zoomLevel}px`, }">
      {{ job['Shipping Agt Name'] }}
    </div>
    <div class="cont-operator" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${677 * zoomLevel}px`,
			'left': `${520 * zoomLevel}px`, }">
      {{ cn['ContOperator'] }}
    </div>
    <div class="requested-by" :style="{
      'width': `${225 * zoomLevel}px`,
			'height': `${17 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${692 * zoomLevel}px`,
			'left': `${520 * zoomLevel}px`, }">
      {{ job['Requested By'] }}
    </div>
    <div class="remarks" :style="{
      'width': `${290 * zoomLevel}px`,
			'height': `${45 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${987 * zoomLevel}px`,
			'left': `${450 * zoomLevel}px`, }">
      {{ cn['Remarks'] }}
    </div>
    <div class="delivery-type" :style="{
      'width': `${300 * zoomLevel}px`,
			'height': `${30 * zoomLevel}px`,
			'font-size': `${10 * zoomLevel}px`,
			'position': 'absolute',
			'top': `${1042 * zoomLevel}px`,
			'left': `${20 * zoomLevel}px`, }">
      {{ cn['DeliveryType'] == 'SL' ? 'SIDELOADER' : cn['DeliveryType'] == 'TP' ? 'TIPPER' : cn['DeliveryType'] == 'GS' ? 'GENSET' : '' }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      job: {},
      cn: {},
    }
  },
  props: {
    data: { type: Object, default: function() { return {}; }},
    printData: { type: Object, default: function() { return {}; }},

    properties: { type: Object, default: function() { return null; }},
    zoomLevel: { type: Number, default: 1 },
    fontPtPx: { type: Number, default: 1 },
    print: { type: Boolean, default: false },
  },
  methods: {
    getLastDay: function() {
      if (this.job['CN Job Type'] == 'EXP' || this.job['CN Job Type'] == '1-EXP') {
        let etaDate = Date.parse(this.job['POD ETA']);
        if (etaDate) {
          return this.$dateTime.getDateTimeDifferenceByDay(new Date(), etaDate) == 0 ? 'LAST DAY' : '';
        } else { return '' }
      } else { return '' }
    },
    getTotalAmount: function() {
      if (this.cn['HaulageRate'] || this.cn['HaulageRate']) {
        let haulage = parseInt(this.cn['HaulageRate']) ? parseInt(this.cn['HaulageRate']) : 0;
        let toll = parseInt(this.cn['TollRate']) ? parseInt(this.cn['TollRate']) : 0;
  
        return haulage + toll;
      }
    }
  },
  mounted() {
    this.job = this.properties['details'] ? this.properties['details'] : {};
    this.cn = this.properties['cns'] ? this.properties['cns'] : {};
  },
  watch: {
  }
}
</script>

<style scoped>
/* div { border: 1px solid gray; } */
</style>